/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MensagemErrorHandlerService as ɵa} from './error-handler/mensagem-error-handler.service';